var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntityButtonQuickbooks(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2CA01C",
    d: "M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 11a7 7 0 000 14h1v-2.6h-1A4.403 4.403 0 017.6 18c0-2.428 1.972-4.4 4.4-4.4h2.404v13.6a2.6 2.6 0 002.6 2.6V11H12zm12.004 14a7 7 0 000-14h-1v2.6h1c2.428 0 4.4 1.972 4.4 4.4s-1.972 4.4-4.4 4.4H21.6V8.8A2.6 2.6 0 0019 6.2V25h5.004z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntityButtonQuickbooks);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/entityButtonQuickbooks.a0f07362.svg";
export { MemoForwardRef as ReactComponent };